<div class="create-form create-activity-form-container">
  <div class="form-wrapper" fxLayout="row" fxLayoutAlign="center none">
    <form
      (ngSubmit)="submit()"
      novalidate
      [formGroup]="stimulusForm"
      fxFlex="85"
      fxFlex.lt-md="100"
      fxLayout="column"
      fxLayoutAlign="center stretch"
      >
      <h2 class="form-head">Details</h2>
      <div class="required">Required *</div>
      <!-- Title, Level, Score Possible, Share With, Unit section  -->
      <section class="main-form-details-container">
        <!-- Title -->
        <mat-form-field class="stimulusTask-form__taskShortDirection">
          <mat-label>Title</mat-label>
          <input
            matInput
            type="text"
            formControlName="displayName"
            (keyup)="onChange()"
            />
          <mat-error
            print-error
            [control]="stimulusForm.get('displayName')"
            fieldName="{{ activityName }} activity title"
            >
          </mat-error>
        </mat-form-field>

        <!-- Distributor ONLY -->
        @if (
          isDistributor &&
          activePrograms &&
          activePrograms.length > 0
          ) {
          <mat-form-field
            class="stimulusTask-form__program"
            >
            <mat-label>Program</mat-label>
            <mat-select
              formControlName="subjectId"
              (selectionChange)="onSubjectChange($event)"
              >
              @for (program of activePrograms; track program) {
                <mat-option
                  [value]="program.subjectId"
                  >
                  {{ program?.subjectName }}
                </mat-option>
              }
            </mat-select>
            <mat-error
              print-error
              [control]="stimulusForm.get('subjectId')"
              fieldName="Program"
              >
            </mat-error>
          </mat-form-field>
        }

        <!-- Level -->
        <mat-form-field class="stimulusTask-form__level">
          <mat-label>{{ levelLabel }}</mat-label>
          <mat-select
            formControlName="levelIds"
            [disabled]="!subjectId && !isDistributor"
            (selectionChange)="onChange()"
            >
            @for (level of stimulusLevels; track level) {
              <mat-option
                [value]="level.levelId"
                >
                {{ level.levelName }}
              </mat-option>
            }
          </mat-select>
          <mat-error
            print-error
            [control]="stimulusForm.get('levelIds')"
            fieldName="{{ levelLabel }}"
            >
          </mat-error>
        </mat-form-field>

        <!-- Score Possible -->
        <mat-form-field class="stimulusTask-form__scorePossible">
          <mat-label>Score Possible</mat-label>
          <input
            matInput
            type="text"
            formControlName="scorePossible"
            (keyup)="onChange()"
            />
          <mat-error
            print-error
            [control]="stimulusForm.get('scorePossible')"
            fieldName="Score possible"
            >
          </mat-error>
        </mat-form-field>

        <!-- Visibility Options -->
        <mat-form-field class="stimulusTask-form__visibility">
          <mat-label>Share With</mat-label>
          <mat-select
            formControlName="visibility"
            (selectionChange)="onChange()"
            >
            @for (opt of visibilityOpts; track opt) {
              <mat-option
                [value]="opt.key"
                >
                {{ opt.value }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <!-- Unit -->
        @if (subjectId && !ifMathProgram()) {
          <mat-form-field
            class="stimulusTask-form__unit"
            >
            <mat-label>Unit</mat-label>
            <mat-select
              formControlName="unit"
              (selectionChange)="onChange()"
              >
              @for (unit of stimulusUnits; track unit) {
                <mat-option
                  [value]="unit"
                  >
                  {{ unit }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      </section>

      <!-- Url/File Upload section  -->
      <section>
        <!-- Optional URL -->
        <mat-form-field class="stimulusTask-form__url">
          <div class="create-form__note create-form__url-note">
            URLs can include links to youtube/vimeo videos, pdfs,
            and other resources.
          </div>
          <mat-label>URL (optional)</mat-label>
          <input
            matInput
            trimInput
            type="text"
            formControlName="url"
            (keyup)="onChange()"
            />
        </mat-form-field>

        <!-- Optional File upload -->
        <div
          fxLayout="column"
          fxLayoutAlign="start"
          style="padding-top: 20px"
          >
          <span>File (optional)</span>
          <div class="create-form__note create-form__file-note">
            Files can include uploaded images, video, audio,
            documents, and pdfs.
          </div>
        </div>

        <div
          class="assignment-uploader"
          fxLayout="column"
          fxLayoutAlign="center center"
          >
          <div
            ng2FileDrop
            (fileOver)="fileOverBase($event)"
            (onFileDrop)="fileSelected()"
            [uploader]="uploader"
            class="assignment-file-dropzone"
            >
            <h2>Drop File Here</h2>
            <p>Or, if you prefer...</p>

            <input
              type="file"
              ng2FileSelect
              placeholder=""
              #fileUploader
              [uploader]="uploader"
              [hidden]="true"
              (change)="onUploaderChange($event)"
              (onFileSelected)="fileSelected()"
              />

            <button
              id="file-select-button"
              class="file-select-button"
              mat-raised-button
              color="default"
              type="button"
              (click)="fileUploader.click()"
              >
              <mat-icon>folder_open</mat-icon>
              Select File
            </button>

            @if (showFileProgressBar) {
              <mat-progress-bar
                mode="determinate"
                value="{{ uploader.queue[0]?.progress }}"
                >
              </mat-progress-bar>
            }

            @if (mediaUrl) {
              <div
                class="thumbnail"
                fxLayout="row"
                fxLayoutAlign="center center"
                >
                @if (mediaType == 'image') {
                  <span>
                    <img
                      [src]="mediaUrl"
                      alt="Journal Media Image"
                      />
                  </span>
                }
                @if (mediaType == 'video') {
                  <span>
                    <video
                      class="video"
                      playsinline
                      controls
                      [src]="mediaUrl"
                    ></video>
                  </span>
                }
                @if (mediaType == 'other') {
                  <span
                    ><a target="_blank" [href]="mediaUrl"
                    >View Resource Document</a
                    ></span
                    >
                  }
                </div>
              }

              <div class="selected-file-name">
                <p>
                  <strong>{{
                    uploader.queue[0]?.file?.name
                  }}</strong>
                  @if (uploader.queue?.length > 0) {
                    <mat-icon
                      class="clear-icon"
                      aria-label="Auto Evaluate info icon"
                      (click)="clearSubmissionSet()"
                      >clear
                    </mat-icon>
                  }
                  <span class="cdk-visually-hidden"
                    >Clear submission Set</span
                    >
                  </p>
                </div>

                @if (incorrectFileType) {
                  <p class="file-upload-error">
                    Incorrect File Size! Refer to the list below for the
                    correct file types.
                  </p>
                }
                @if (maxFileSizeExceeded) {
                  <p
                    class="file-upload-error"
                    >
                    You've exceeded the max file size! Please upload a
                    file that is 64MB or smaller.
                  </p>
                }

                <p class="helperText uploaderSupportText">
                  <strong>Supported file types:</strong> word, excel,
                  powerpoint, txt, pdf, jpg, png, bmp, gif, mp4, mp3,
                  mov, webm, zip, max, gmx, gmz, unity3d,
                  gameproj
                </p>
                <p class="helperText uploaderSupportText">
                  <strong>Max file size:</strong> 64MB
                </p>
              </div>

              <div>
                <button
                  mat-raised-button
                  color="default"
                  type="button"
                  [disabled]="disableUploadBtn"
                  (click)="uploadFile()"
                  >
                  <mat-icon>cloud_upload</mat-icon>
                  Upload File
                </button>
              </div>
            </div>
          </section>

          <!-- Response Type section -->
          <section>
            <div fxLayout="column" fxLayoutAlign="center center">
              <div style="font-weight: bold; font-size: 16px">
                Response Type*
              </div>
              <div fxLayout="column" fxLayoutAlign="center stretch">
                <div class="stimulusTask__responseTypeUpload">
                  <mat-checkbox
                    formControlName="responseTypeUpload"
                                (change)="
                                    responseTypeButtonChange($event, 'upload')
                                "
                    >Upload File/Url
                  </mat-checkbox>
                </div>
                <div class="stimulusTask__responseTypeShortAnswer">
                  <mat-checkbox
                    formControlName="responseTypeShortAnswer"
                                (change)="
                                    responseTypeButtonChange(
                                        $event,
                                        'shortAnswer'
                                    )
                                "
                    >Write Short Answer
                  </mat-checkbox>
                </div>
                <div class="stimulusTask__responseTypeNone">
                  <mat-checkbox
                    formControlName="responseTypeNone"
                                (change)="
                                    responseTypeButtonChange($event, 'none')
                                "
                    >No Student Response
                  </mat-checkbox>
                </div>
              </div>
            </div>
          </section>

          <!-- Description section -->
          <section>
            <!-- Description -->
            <div class="margin-top-15px">
              <label
                >Description *
                <text-editor
                  placeholder="Description *"
                  [required]="true"
                  formControlName="description"
                  (onContentChanged)="onChange()"
                  (setQuillEditorTouched)="setQuillEditorTouched()"
                ></text-editor>
              </label>
              <mat-error
                class="margin-top-20px"
                print-error
                [control]="stimulusForm.get('description')"
                fieldName="Description"
                >
              </mat-error>
            </div>
          </section>

          <!-- Distributor Only parameters -->
          @if (isDistributor) {
            <div class="distributor-border">
              <div class="metadata-title">Activity Metadata</div>
              <div fxLayout="row" fxLayout.lt-md="column">
                <mat-form-field class="stimulusTask-form__lesson">
                  <mat-label>Lesson</mat-label>
                  <input
                    matInput
                    trimInput
                    type="text"
                    formControlName="lesson"
                    (change)="onChange()"
                    />
                </mat-form-field>
                <mat-form-field
                  class="stimulusTask-form__bookActivityNumber"
                  >
                  <mat-label>Activity Number</mat-label>
                  <input
                    matInput
                    trimInput
                    type="text"
                    formControlName="bookActivityNumber"
                    (change)="onChange()"
                    />
                </mat-form-field>
              </div>
              <div fxLayout="row" fxLayout.lt-md="column">
                <mat-form-field class="stimulusTask-form__spineID">
                  <mat-label>Book ID</mat-label>
                  <input
                    matInput
                    trimInput
                    type="text"
                    placeholder="Book ID"
                    formControlName="bookId"
                    (change)="onChange()"
                    />
                </mat-form-field>
                <mat-form-field class="stimulusTask-form__page">
                  <mat-label>Page Number</mat-label>
                  <input
                    matInput
                    trimInput
                    type="text"
                    placeholder="Page Number"
                    formControlName="page"
                    (change)="onChange()"
                    />
                </mat-form-field>
              </div>
            </div>
          }

          <!--            TODO: CURE: inUse needs to be checked a different way
          <div fxLayout="row" fxLayoutAlign="center center">-->
            <!--                <mat-error *ngIf="exists && currentCustomActivityForm?.inUse">-->
            <!--                    <mat-icon class="warning-icon">warning</mat-icon>-->
            <!--                    Warning: This Activity has outstanding assignments.-->
          <!--                </mat-error>-->
        <!--            </div>-->
        @if (isDistributor) {
          <div
            class="button-set"
            fxLayout="row"
            fxLayoutAlign="center center"
            >
            <button
              type="button"
              mat-raised-button
              class="button--cancel"
              (click)="cancelStimulusTask()"
              >
              Cancel
            </button>
            <button
              mat-raised-button
              color="primary"
              type="submit"
              [disabled]="stimulusForm.invalid || stimulusForm.pristine"
              >
              {{
              !exists
              ? "Create Custom Activity"
              : "Update Custom Activity"
              }}
            </button>
          </div>
        }
      </form>
    </div>
  </div>
